"use strict";

var EmptyMiddleware = require('./EmptyMiddleware');

var OAuthMiddleware = require('./OAuthMiddleware');

var current = new EmptyMiddleware();

function use(middleware) {
  current = middleware;
}

function mw() {
  return current;
}

module.exports = {
  EmptyMiddleware: EmptyMiddleware,
  OAuthMiddleware: OAuthMiddleware,
  use: use,
  mw: mw
};